import { render, staticRenderFns } from "./KpiTotalizers.vue?vue&type=template&id=6f8f3ef7&scoped=true"
import script from "./KpiTotalizers.vue?vue&type=script&lang=js"
export * from "./KpiTotalizers.vue?vue&type=script&lang=js"
import style0 from "./KpiTotalizers.vue?vue&type=style&index=0&id=6f8f3ef7&prod&lang=scss&scoped=true"
import style1 from "./KpiTotalizers.vue?vue&type=style&index=1&id=6f8f3ef7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f3ef7",
  null
  
)

export default component.exports